<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Tipuri masini" @on_add_clicked="show_dialog()" :AdaugaVisible="true" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()" label-position="top">
              <el-row style="margin: 10px" gutter="12" class="input-group">
                <el-col :md="12">
                  <el-form-item label="Nume">
                    <el-input v-model="Filters.Nume" />
                  </el-form-item>
                </el-col>
                <el-col :md="12">
                  <el-form-item label="Tip">
                    <el-select v-model="Filters.Tip" placeholder="Selectează" clearable>
                      <el-option label="Toate" value=""></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      <el-table-column prop="Id" label="ID"></el-table-column>
      <el-table-column prop="Nume" label="Nume"></el-table-column>
      <el-table-column prop="Marca" label="Marca"></el-table-column>
      <el-table-column label="Tip">
        <template slot-scope="scope">
          <span v-if="scope.row.Tip === 'Normal'">Normal</span>
          <span v-else-if="scope.row.Tip === 'Suv'">SUV</span>
          <span v-else-if="scope.row.Tip === 'Autoutilitar'">Autoutilitar</span>
          <span v-else-if="scope.row.Tip === 'Supercar'">Supercar</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Modificare">
            <el-button type="primary" icon="el-icon-edit" circle @click="show_dialog(scope.row.Id)" />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button type="danger" icon="el-icon-delete" circle @click="delete_item(scope.row)" />
          </el-tooltip>
        </template>
      </el-table-column></el-table>
    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Tipuri-masini-dialog class="custom-width" ref="dlg" @save="refresh_info()" /></base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Tipuri_masini_dialog from "@/pages/Admin/tipuri_masini/Tipuri_masini_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "tipuri_masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Tipuri-masini-dialog": Tipuri_masini_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Nume: "",
        Tip: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },


  methods: {
    async get_info() {
      var response = await this.post("tipuri_masini/get_info");
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("tipuri_masini/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("tipuri_masini");
    },
    reset() {
      this.Filters = {
        Nume: "",
        Tip: "",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Sunteti sigur ?`, "Warning");
      if (confirm) {
        await this.post("tipuri_masini/delete_item", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
